import { useMemo } from 'react';

const getScrollbarWidth = () => {
    // thanks too https://davidwalsh.name/detect-scrollbar-width
    // via https://react-table.tanstack.com/docs/examples/virtualized-rows
    const scrollDiv = document.createElement('div');
    scrollDiv.setAttribute(
        'style',
        'width: 100px; height: 100px; overflow: scroll; position:absolute; top:-9999px;',
    );
    document.body.appendChild(scrollDiv);
    const scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
    document.body.removeChild(scrollDiv);
    return scrollbarWidth;
};

export default () => useMemo(() => getScrollbarWidth(), []);
